// Uses bit shifting to store sort indexes for 3 sections in one integer for up
// to 255 questions.
// https://stackoverflow.com/questions/37305266/how-do-i-save-multiple-small-integers-in-one-integer-via-bitshifting

const newSortIndex = (a, b, c) => {
  return (a & 0xFF) | ((b & 0xFF) << 8) | ((c & 0xFF) << 16);
}

const getSortIndexValues = (i) => ({
  monitoring: i & 0xFF || i,
  assessment: (i >> 8) & 0xFF || i,
  controlRules: (i >> 16) & 0xFF || i
});

const getSortIndex = (section, i) => getSortIndexValues(i)[section];

const updateSortIndex = (section, value, currentIndex) => {
  if (value === 0) {
    throw new Error('sortIndex must be > 1');
  }
  const indexes = getSortIndexValues(currentIndex);
  indexes[section] = value;
  return newSortIndex(
    indexes["monitoring"],
    indexes["assessment"],
    indexes["controlRules"]
  )
}

export {getSortIndex, updateSortIndex, newSortIndex, getSortIndexValues};
